import { type FC } from 'react';

import { Box } from '../../Box';
import {
  type FeatureItem,
  type FeatureListItemProps,
  FeatureListItem,
} from '../../FeatureList';
import { Text } from '../../Typography';
import {
  calculateHostingDuration,
  formatHostingDuration,
} from '../LandownerProfile.helpers';

export type ProfileSubtitleProps = {
  /**
   * ISO date string when hosting started.
   * If provided, will calculate and display years and months.
   */
  hostingSince?: string;
  /**
   * Optional feature item for reviews display
   */
  featureReviewItem?: FeatureItem;
};

const ProfileSubtitle: FC<ProfileSubtitleProps> = ({
  hostingSince,
  featureReviewItem,
}) => {
  // Calculate duration from date if provided
  const duration = hostingSince ? calculateHostingDuration(hostingSince) : null;
  const formattedDuration = formatHostingDuration(duration);

  const displayText = formattedDuration ? `${formattedDuration} Hosting` : null;

  return (
    <Box display="flex" flexDirection="column" gap="2px">
      {displayText && (
        <Text size="sm" color="text-secondary">
          {displayText}
        </Text>
      )}

      {featureReviewItem && (
        <FeatureListItem {...(featureReviewItem as FeatureListItemProps)} />
      )}
    </Box>
  );
};

export default ProfileSubtitle;
